import { utils } from "ethers";

import { CONFIG } from "../config/config";

interface Options {
  fixed?: number;
}

export const displayFloat = (
  value: number | string | null | undefined,
  { fixed }: Options = {}
): string => {
  try {
    const parsedValue = value || 0;
    if (typeof parsedValue === "string" || parsedValue > 0) {
      const currencySymbolIndex = parsedValue
        .toString()
        .indexOf(CONFIG.defaultCurrency.symbol);
      const addSymbol = (value: string) => {
        return currencySymbolIndex === -1
          ? value
          : currencySymbolIndex === 0
          ? `${CONFIG.defaultCurrency.symbol} ${value}`
          : `${value} ${CONFIG.defaultCurrency.symbol}`;
      };
      const valueToDisplay =
        parsedValue
          .toString()
          .replaceAll(CONFIG.defaultCurrency.symbol, "")
          .trim()
          .match(
            new RegExp(
              `^-?\\d*\\.?0*\\d{0,${fixed === undefined ? "" : fixed}}`
            )
          )?.[0] || "0";

      const isInteger = Number(valueToDisplay) % 1 === 0;
      if (isInteger) {
        return addSymbol(Number(parsedValue).toString());
      }
      return fixed !== undefined
        ? Number(valueToDisplay).toFixed(fixed) === (0).toFixed(fixed)
          ? addSymbol(`<${10 ** -fixed}`)
          : addSymbol(Number(valueToDisplay).toFixed(fixed))
        : addSymbol(valueToDisplay + "");
    }
    return "0";
  } catch (e) {
    console.error(e);
    return "0";
  }
};

export const calcPrice = (value: string, decimals: string): string => {
  try {
    return utils.formatUnits(value, decimals);
  } catch (e) {
    console.error(e);
    return "";
  }
};
